import { useLayoutEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';

import useForm from '../../../hooks/useForm';

import { useAppContext } from '../../../contexts/app';
import { useUserContext } from '../../../contexts/user';

import { getAvailableClients } from '../../../services/Users';

const useChangeClient = () => {
  const { handleAlert } = useAppContext();
  const {
    userSession,
    mfaData,
    openClientModal,
    handleChangeClientId,
    handleCloseClientModal,
    handleVerifyTokenAndChangeClientId,
  } = useUserContext();

  const [clients, setClients] = useState([]);
  const [showClients, setShowClients] = useState(false);

  const { formData, handleOnChange, changeFormData } = useForm({
    clientId: userSession?.clientId || '',
    mfaToken: '',
    trustDevice: true,
    device: '',
  });

  const needsToken = Boolean(mfaData?.needsToken);

  useLayoutEffect(() => {
    setShowClients(!needsToken);
  }, [needsToken]);

  useLayoutEffect(() => {
    if (!formData.trustDevice) {
      changeFormData({
        device: '',
      });
    } else {
      const parser = new UAParser();
      const browser = parser.getBrowser();
      const os = parser.getOS();

      changeFormData({
        device: `${browser.name} ${os.name}`,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.trustDevice]);

  useLayoutEffect(() => {
    const loadClients = async () => {
      try {
        const [clientsList] = await Promise.all([getAvailableClients()]);

        setClients(clientsList);
      } catch (error) {
        handleAlert(error, 'error');
      }
    };
    if (showClients) {
      loadClients();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showClients]);

  const handleSubmit = async (data) => {
    if (!showClients) {
      const { isValid, hasClientId } = await handleVerifyTokenAndChangeClientId(data);

      if (isValid && !hasClientId) {
        setShowClients(true);
      }
    } else {
      handleChangeClientId(data);
    }
  };

  const handleChangeTrustDevice = () => {
    changeFormData({
      trustDevice: !formData.trustDevice,
    });
  };

  return {
    showClients,
    clients,
    mfaData,
    formData,
    openClientModal,
    handleSubmit,
    handleOnChange,
    handleChangeClientId,
    handleCloseClientModal,
    handleChangeTrustDevice,
  };
};

export default useChangeClient;
